const types = {
  SHOW_GLOBAL_LOADING: 'SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'HIDE_CONFIRMATION_DIALOG',
  SHOW_MENSAGEM: 'SHOW_MENSAGEM',
  HIDE_MENSAGEM: 'HIDE_MENSAGEM',
  SET_MENSAGEM: 'SET_MENSAGEM'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/ui/mutations-types.js